import React from 'react';
import { Eye } from 'lucide-react';

// Function to format date as DD-MMM-YYYY
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const CampaignTable = ({ data, loading, onSeeDetails }) => {
  console.log('data', data);
  return (
    <div className="">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow">
          <thead className="bg-blue-100 text-blue-700">
            <tr>
              <th className="px-4 py-2 text-left">Campaign ID</th>
              <th className="px-4 py-2 text-left">Created By</th>
              <th className="px-4 py-2 text-left">Type</th>
              <th className="px-4 py-2 text-left">Created On</th>
              <th className="px-4 py-2 text-left"># Feedbacks Initiated</th>
              <th className="px-4 py-2 text-left"># Completed</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-3 py-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {data && data?.length > 0 && data.map((item, index) => {
              const user = item.created_by_user_details;
              return (
                <tr key={index} className="border-t border-gray-200">
                  <td className="px-4 py-2">{item.assessment_id}</td>
                  <td className="px-4 py-2">{user.user_name}</td>
                  <td className="px-4 py-2">{item?.assessment_type}</td>
                  <td className="px-4 py-2">{formatDate(item.created_time)}</td>
                  <td className="px-4 py-2">{item.total_users}</td>
                  <td className="px-4 py-2">{item.completed_users}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded text-sm ${item.current_status === 'Completed'
                          ? 'bg-green-100 text-green-700'
                          : item.current_status === 'In Progress'
                            ? 'bg-yellow-100 text-yellow-700'
                            : 'bg-gray-100 text-gray-700'
                        }`}
                    >
                      {item.current_status}
                    </span>
                  </td>
                  <td className="p-3">
                    <button
                      onClick={() => onSeeDetails(item?.assessment_id,item?.created_by_user)}
                      className="text-blue-600 border border-blue-300 px-3 py-1 rounded-md hover:bg-blue-100 flex items-center"
                    >
                      <Eye className="mr-2 h-4 w-4" />
                      Details
                    </button>
                  </td>
                </tr>
              );
            })}
             {data?.length === 0 && (
                        <tr>
                            <td colSpan="4" className="text-center p-4 text-gray-500">
                                No users found
                            </td>
                        </tr>
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignTable;